import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MicrositeModule } from './microsite/microsite.module';
import { AppComponent } from './app.component';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'business-page',
    pathMatch: 'full',
  },
  {
    path: '',
    component: AppComponent,
    children: [
      {
        path: '',
        loadChildren: () => MicrositeModule
      }
    ]
  }
];
